export const skills = [
    { name: "C#", icon: "mdi:language-csharp" },
    { name: "Rust", icon: "mdi:language-rust" },
    { name: "TypeScript", icon: "mdi:language-typescript" },
    { name: "JavaScript", icon: "mdi:language-javascript" },
    { name: "React", icon: "mdi:react" },
    { name: "Flutter", icon: "mdi:alpha-f" },
    { name: "MySql", icon: "mdi:database" },
    { name: "Git", icon: "mdi:git" },
    { name: "AWS", icon: "mdi:aws" },
    { name: "Tailwind", icon: "mdi:tailwind" },
    { name: "HTML", icon: "mdi:language-html5" },
    { name: "CSS", icon: "mdi:language-css3" },
];